<template>
    <div>
        <div class="entry">
            <div class="entry-item" v-for="item in entry" v-bind:key="item.id">
                <img :src="item.imageUrl" @click="gotoDetail(item.link)"/>
            </div>
        </div>
        <div class="index-line"></div>
    </div>
</template>

<script>
export default {
    props:{
        entry:Array
    },
    methods:{
        gotoDetail(url){
            window.open(url);
        }
    }
}
</script>

<style scoped>
.entry{
    height: 171px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}
.entry-item img{
    cursor: pointer;
}
.entry-item img:hover{
    filter: brightness(120%)
}

</style>


// WEBPACK FOOTER //
// src/components/Entry.vue